import DocumentListConnected from './DocumentListConnected'
export default DocumentListConnected
